import { IExtra } from "@appNeo/core/interfaces/IExtra";
import { IMenu } from "@appNeo/core/interfaces/IMenu";
import { IPaquete } from "@appNeo/core/interfaces/IPaquete";
import { ITarifa } from "@appNeo/core/interfaces/ITarifa";
import { ITipoEvento } from "@appNeo/core/interfaces/ITipoEvento";
import { ITipoMenu } from "@appNeo/core/interfaces/ITipoMenu";
import { ITipoTurno } from "@appNeo/core/interfaces/ITipoTurno";
import { IFicheroExtendido } from "@appNeo/neoShared/helpers/interfaces/IFichero";
import { AccionesTablaEnum } from "@appNeo/neoShared/services/tabla/tabla.service";
import { LoremIpsum } from "lorem-ipsum";

const loremIpsum = new LoremIpsum();

export const TARIFAS: ITarifa[] = [
    {
        id: '1',
        identificador: 'TAR0001',
        nombre: 'Tarifa A',
        porcentajeDescuento: 10.10,
        activa: false
    },
    {
        id: '2',
        identificador: 'TAR0002',
        nombre: 'Tarifa B',
        porcentajeDescuento: 10.10,
        activa: true
    },
    {
        id: '3',
        identificador: 'TAR0003',
        nombre: 'Tarifa C',
        porcentajeDescuento: 10.10,
        activa: true
    },
];



export const TIPOS_MENU: ITipoMenu[] = [
    {
        id: "1100001",
        nombre: "Padres",
        descripcion: "Tipo menú niño"
    },
    {
        id: "1100002",
        nombre: "Niños",
        descripcion: "Tipo menú adulto"
    },
]

export const EXTRAS = [
    {
        id: "1",
        identificador: 'EXT0001',
        nombre: 'Piscina',
        numeroCondicionantes: 2,
        duracion: 3,
        precio: 105,
        activo: true,
        rutaImagen: 'https://picsum.photos/seed/picsum/200/300',
    },
    {
        id: "2",
        identificador: 'EXT0002',
        nombre: 'Payaso',
        numeroCondicionantes: 4,
        duracion: 2,
        precio: 200,
        activo: true,
        rutaImagen: 'https://picsum.photos/seed/picsum/200/300',
    },
]

export const EXTRAIMGPRINCIPAL: IFicheroExtendido = {
        id: '1',
        iconDrag: {nombre: 'Icono Arrastre Drag', class: 'icon-20 icon-ibm--draggable text-grey500'},
        nombre: 'imagen2.jpg',
        extension: '.jpg',
        peso: 200,
        posicion: 3,
        tituloSeo: 'Titulo seo ejemplo',
        textoAlternativoSeo: 'Texto alternativo ejemplo',
        imagen: {
          src: 'https://picsum.photos/seed/picsum/1920/1080'
        },
        acciones: [
          {
            idAccion: AccionesTablaEnum.Editar,
            tooltip: 'Editar',
            icono: true,
            iconClass: 'icon-20 icon-ibm--edit',
            disabled: false,
          },
          {
            idAccion: AccionesTablaEnum.Eliminar,
            tooltip: 'Eliminar',
            icono: true,
            iconClass: 'icon-20 icon-ibm--trash-can text-danger',
            disabled: false,
          },
        ],
};
// const date = new Date();
// export const PAQUETES: IPaquete [] = [
//     {
//         id: "1",
//         identificador: 'PAQ001',
//         nombre: 'VIP Piscina',
//         descripcion: 'Descripción del paquete',
//         textoEdadMinima: 'No existe',
//         descripcionHorario: 'Horario descripción',
//         duracionEvento: 150,
//         precio1: 100,
//         precio2: 150,
//         horaInicio: '23:37:57',
//         activo: true,
//         imagenes: [
//             {
//                 idPaquete: '1',
//                 posicion: 3,
//                 nombre: 'Img 1 paquete',
//                 fechaAlta: new Date(),
//                 fechaModificacion: new Date(),
//                 title: 'Tittle Paquete',
//                 alt: 'Alt Paquete',
//                 principal: true
//             }
//         ],
//         extras: [EXTRAS[0].nombre, EXTRAS[1].nombre]
//     }
// ]

export const TIPOS_EVENTO: ITipoEvento[] = [
    {
        id: "3100001",
        nombre: "Cumpleaños",
        descripcion: ""
    },
    {
        id: "3100002",
        nombre: "Comuniones",
        descripcion: ""
    },
    {
        id: "3100003",
        nombre: "Otros",
        descripcion: ""
    },
]


export const TIPOS_TURNO: ITipoTurno[] = [
    {
        id: "2100001",
        nombre: "Mañana",
        descripcion: ""
    },
    {
        id: "2100002",
        nombre: "Tarde",
        descripcion: ""
    },
]
